// hooks/use-business-account-detail.ts
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useGetBusinessAccountDetails } from '../../../apis/bussiness-accounts/bussiness-account-details';

const useBusinessAccountDetail = () => {
    const { id } = useParams();
    const [image, setImage] = useState<string | null>(null);
    const [zoomed, setZoomed] = useState(false);

    const { data, isFetching: loading } = useGetBusinessAccountDetails(id || "");

    const details = data?.data
        ? { ...data.data, totalOrders: data.totalOrders, completedOrders: data.completedOrders }
        : null;

    const handleZoomImage = (src: string) => {
        setImage(src);
        setZoomed(true);
    };

    return {
        id,
        details,
        loading,
        image,
        zoomed,
        setZoomed,
        handleZoomImage,
    };
};

export default useBusinessAccountDetail;